import { Flex } from '../../layout/Flex';
import { AdvertisingCatalogEmpty } from '../AdvertisingCatalogEmpty/AdvertisingCatalogEmpty';
import { AdvertisingShopCard } from '../AdvertisingShopCard/AdvertisingShopCard';
import { AdvertisingShopCardSkeleton } from '../AdvertisingShopCard/parts/AdvertisingShopCardSkeleton/AdvertisingShopCardSkeleton';
import { SKELETON_COUNT } from './constants';
import { AdvertisingShopsProps } from './types';

export const AdvertisingShops: React.FC<AdvertisingShopsProps> = ({ isLoading, shops }) => {
    if (!shops || isLoading) {
        return (
            <Flex
                flexWrap="wrap"
                direction={{ sm: 'row' }}
                alignItems="stretch"
                width="100%"
                spacing={1}
            >
                {new Array(SKELETON_COUNT).fill('').map(() => (
                    <AdvertisingShopCardSkeleton
                        width={{ xs: 'calc(50% - 4px)', sm: 'calc(25% - 6px)' }}
                    />
                ))}
            </Flex>
        );
    }

    if (shops?.length) {
        return (
            <Flex
                flexWrap="wrap"
                direction={{ sm: 'row' }}
                alignItems="stretch"
                width="100%"
                spacing={1}
            >
                {shops.map((shop) => (
                    <AdvertisingShopCard
                        {...shop}
                        width={{ xs: 'calc(50% - 4px)', sm: 'calc(25% - 6px)' }}
                    />
                ))}
            </Flex>
        );
    }

    return <AdvertisingCatalogEmpty />;
};
